import { SubSection } from "context/BlogContext";
import * as Yup from "yup";

export const listInitialValues = (subSection: SubSection) => ({
  title: subSection?.title || "",
  style: subSection?.attrs?.style || "",
  items: subSection?.attrs?.items || [""], 
});

export const listValidationSchema = Yup.object({
  style: Yup.string().required("Style is required"),
  items: Yup.array()
  .of(Yup.string().required("Item is required")) // Validate each string in the array
  .min(1, "At least one item is required") // Minimum array length
  .required("Items field is required")
//   items: Yup.string().required("Items is required"),
});
